import styled from 'styled-components'

export const Container = styled.div`
  padding: 2rem;
  margin: -2rem;
`

export const Err = styled.div``
